// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo } from 'react'
import { getVisitsConfig } from '../VisitConstants'
import { VisitsTableRow } from './VisitsTableRow'

export const VisitsTableContainer = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ visits, visitsMode, setTriggerTabId, onClickRemarks, timeZone, setSelectedVisitId }) => {
    const visitsConfig = getVisitsConfig(visitsMode)

    const gridTemplateColumns = visitsConfig.map((item) => item.width || '1fr').join(' ')
    const visitsTableStyles = { gridTemplateColumns }

    return (
      <section className='visits-content'>
        {/*
         // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
        {visits.map(({ VisitId, ...visit }) => (
          <div key={VisitId} className='visits-table-container' style={visitsTableStyles}>
            <VisitsTableRow
              visit={visit}
              setTriggerTabId={setTriggerTabId}
              setSelectedVisitId={setSelectedVisitId}
              visitId={VisitId}
              visitsMode={visitsMode}
              onClickRemarks={onClickRemarks}
              timeZone={timeZone}
            />
          </div>
        ))}
      </section>
    )
  },
)
